// ─── DevOps · Valoraciones, índice ───
//
// `/app/devops` exacto — la lista de clientes. Vive aquí y no en `devops.tsx` porque ese fichero
// pasó a ser LAYOUT al aparecer `devops.$clienteRef.tsx`: un layout sin `<Outlet/>` se traga en
// silencio todas sus rutas hijas, que es la trampa que documenta `dashboards.tsx`.
//
// 🚨 Aquí vive además la compatibilidad con las URL viejas `?cliente=<uuid>`. El dueño pidió
// explícitamente no romperlas («no queremos romper algo si tienen marcadores»), así que un enlace
// guardado sigue funcionando y aterriza —con `replace`— en la dirección nueva.

import { createFileRoute } from '@tanstack/react-router';
import { DevOpsIndexRoute } from '../../features/devops/DevOpsIndexRoute';

export const Route = createFileRoute('/app/devops/')({
  component: DevOpsIndexRoute,
});
